module.exports = __webpack_public_path__ + "static/media/BGP-CHHSeries.077b85a8.pdf";